import { Text } from "@medoma/components/Text/Text";
import { WarningIconPopover } from "./WarningIconPopover";
import styles from "./WarningsPopover.module.scss";

export const WarningsPopover = ({ warnings }: { warnings: string[] }) => {
  const ariaLabel = warnings.join(", ");

  return (
    <WarningIconPopover ariaLabel={ariaLabel}>
      <ul className={styles.list}>
        {warnings.map((warning) => (
          <li key={warning}>
            <Text element="span" size="small">
              {warning}
            </Text>
          </li>
        ))}
      </ul>
    </WarningIconPopover>
  );
};
